export default class TopNavigation {
    constructor(elm) {
        this.didScroll = false;
        this.lastScrollTop = 0;
        this.delta = 5;
        this.header = elm;
        this.offset = this.header.offsetHeight;

        window.onscroll = () => {
            this.didScroll = true;
        };

        setInterval(() => {
            if (this.didScroll) {
                this.hasScrolled();
                this.didScroll = false;
            }
        }, 250);

        const isMobileNavigation = this.header.querySelector('.header__burger-menu')
        if (isMobileNavigation !== null) {
            isMobileNavigation.addEventListener('click', e => {
                e.preventDefault();
                document.body.classList.toggle('mobile-menu-open', !document.body.classList.contains('mobile-menu-open'));
            });
        }
        
        this.hasScrolled()
    }

    hasScrolled() {
        const st = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

        if (Math.abs(this.lastScrollTop - st) <= this.delta) return;

        this.header.classList.toggle('scrolled', st > this.offset);
        this.header.classList.toggle('nav-down', (st > this.lastScrollTop && st));
        this.header.classList.toggle('nav-up', (st > this.lastScrollTop && st));

        this.lastScrollTop = st;
    }
}
